//@flow
import { connect } from 'react-redux';
import I18n from '../../lib/i18n';
import SuspendSwapTerminateSuccess from './SuspendSwapTerminateSuccess.container';
import { customerEmailSelector } from '../../modules/Customer/selectors';
import theme from '../../theme-config';

import type { StateProps } from '../../components/SuccessPage/SuccessPage';
import type { StateType } from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  successImage: theme.lineTerminationSuccessImage,
  successTitle: I18n.t('Dashboard.LineTermination.terminationSuccessTitle', {
    customerEmail: customerEmailSelector(state),
  }),
  confirmButtonText: I18n.t('Dashboard.LineTermination.confirmButton'),
});

export default connect(mapStateToProps)(SuspendSwapTerminateSuccess);
